import React from "react";

const buildLabel = (names) => {
  if (names.length === 1) return `${names[0]} is typing`;
  if (names.length === 2) return `${names[0]} and ${names[1]} are typing`;
  return `${names[0]} and ${names.length - 1} others are typing`;
};

const TypingIndicator = ({ typingUsers }) => {
  const names = Object.values(typingUsers || {}).filter(Boolean);
  if (!names.length) return null;

  return (
    <div className="bc-typing-strip" aria-live="polite">
      <span className="bc-typing-dots" aria-hidden>
        <span className="bc-typing-dot" />
        <span className="bc-typing-dot bc-typing-dot-2" />
        <span className="bc-typing-dot bc-typing-dot-3" />
      </span>
      <span className="bc-typing-label">{buildLabel(names)}</span>
    </div>
  );
};

export default TypingIndicator;
